'use client'

import { Button, OverlayArrow, Tooltip, TooltipTrigger } from 'react-aria-components'

function handlePrint() {
  window.print()
}

export default function PrintBtn({
  btnClass = 'inline-flex h-40 w-40 items-center justify-center rounded-sm text-fg-title hover:bg-theme-accent transition-colors duration-200 ease-in-out',
}: {
  btnClass?: string
}) {
  return (
    <TooltipTrigger delay={0}>
      <Button className={btnClass} onPress={handlePrint}>
        <svg className="pointer-events-none h-24 w-24" aria-hidden="true">
          <use href={`${process.env.NEXT_PUBLIC_SPRITE_PATH}#icon-print`}></use>
        </svg>
      </Button>
      <Tooltip>
        <OverlayArrow>
          <svg width={8} height={8} viewBox="0 0 8 8">
            <path d="M0 0 L4 4 L8 0" />
          </svg>
        </OverlayArrow>
        Print
      </Tooltip>
    </TooltipTrigger>
  )
}
